import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody26.css';

import clientimg from '../images/case-study-client26.webp'
import outcome from '../images/outcome26.webp'

import sm1 from '../images/cs26so1.webp'
import sm2 from '../images/cs26so2.webp'
import sm3 from '../images/cs26so3.webp'
import sm4 from '../images/cs26so4.webp'


const Casestudybody26 = () => {

    return (
        <>
          <section className='casestudybody26-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A real estate development company focused on building large-scale and mixed-use projects </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client was looking to conduct a comprehensive feasibility study for a proposed hotel development in a city with growing tourism & commercial activity</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody26-section bg-gredient-dark'>
        <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology:</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    <div className='text'>
                            {/* <p>Our team employed a structured and detailed process to meet the client's specific requirements:</p> */}
                        </div>
                    
                    <div className='method-stage'>Market & Demand Analysis</div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>Conducted a <span style={{color:"#03A393"}}>detailed market and demand analysis,</span> leveraging secondary data sources <span style={{color:"#03A393"}}>to examine occupancy trends, ADR benchmarks, tourism dynamics, and macro-economic indicators</span> across similar cities and hotel categories </p>
                        </div>
                      </div>


                      <div className='method-stage'>Competitive Landscape Mapping</div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>Mapped the competitive landscape, profiling <span style={{color:"#03A393"}}>existing supply in the target location by brand, positioning, room inventory, and performance</span> metrics to identify opportunities for differentiation </p>
                        </div>
                      </div>


                      <div className='method-stage'> Development Scenario Evaluation</div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>Identified and assessed development scenarios, evaluating <span style={{color:"#03A393"}}>variations in room count, amenities, and operating models</span> to support scenario-based financial planning </p>
                        </div>
                      </div>

                      <div className='method-stage'> Capex & Opex Benchmarking</div>
                
                <div className='list-text my-3'>
                    <div className='icon'>
                    
                    </div>
                    <div className='text'>
                        <p>Benchmarked <span style={{color:"#03A393"}}>capex & opex assumptions</span> using <span style={{color:"#03A393"}}>regional case studies</span> and <span style={{color:"#03A393"}}>operator disclosures</span> to ensure market-aligned inputs</p>
                    </div>
                  </div>

                  <div className='method-stage large'> Financial Modeling and Sensitivity Analysis</div>
                
                <div className='list-text last my-3'>
                    <div className='icon'>
                    
                    </div>
                    <div className='text'>
                        <p>Developed a flexible and dynamic <span style={{color:"#03A393"}}>financial model</span> projecting <span style={{color:"#03A393"}}>6 year financial performance, including sensitivity analyses across ADR, occupancy, cost assumptions</span> under different ownership and operator structures (owner-operated, hotel management agreement, lease agreement)</p>
                    </div>
                  </div>
                 
                 
             
                      <h3 className='mt-5'>Sample Output</h3>
                      {/* <p><span style={{fontWeight:700}}>Case in Point:</span> We meticulously prepared a comprehensive Portfolio Dashboard and an in-depth Fund Summary. These tools assisted in quickly extracting the performance summary of the fund without much client's involvement.</p> */}
                      <div className='sample-output1 mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                       
                      </div>
            
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody26-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client leveraged the feasibility study to validate project viability, align internal stakeholders and engage potential investors. The analysis supported both capital planning and strategic positioning for the proposed development</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody26
